import { render } from "./NotFound.vue?vue&type=template&id=25251792"
const script = {}
script.render = render

export default script